export default __webpack_public_path__ + "static/media/img_1.1a8c986d.jpg";